export enum PaymentSourceType {
  CREDIT_CARD = "CREDIT_CARD",
  BANK_ACCOUNT = "BANK_ACCOUNT",
  MONEYGRAM = "MONEYGRAM_STATIC_INFO",
}

export enum CreditCardFields {
  CARD_HOLDER = "cardholder",
  CARD_NUMBER = "cardNumber",
  CVV = "cvv",
  STREET_ADDRESS = "streetAddress",
  STREET_ADDRESS_2 = "streetAddress2",
  CITY = "city",
  STATE = "state",
  EXP_DATE = "expDate",
  ZIP = "zip",
  NICKNAME = "nickname",
}

export enum BankAccountFields {
  ACCOUNT_HOLDER = "accountHolder",
  ACCOUNT_TYPE = "accountType",
  ROUTING_NUMBER = "routingNumber",
  ACCOUNT_NUMBER = "accountNumber",
  CONFIRM_ACCOUNT_NUMBER = "confirmAccountNumber",
  NICKNAME = "nickname",
}
